type digit = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
type MM = `0${digit}` | '10' | '11' | '12';
type DD = `${0 | 1 | 2}${digit}` | `${1 | 2 | 3}${0}` | '31';
type YYYY = `19${digit | 0}${digit | 0}` | `20${digit | 0}${digit | 0}`;
export type TDate = `${YYYY}-${MM}-${DD}`;
type HH = `${0 | 1}${digit | 0}` | `2${0 | 1 | 2 | 3}`;
type mm = `${0 | 1 | 2 | 3 | 4 | 5}${digit | 0}`;
export type TTime = `${HH}:${mm}`;

export const WEEK_DAYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'] as const;
export const DATE_FORMAT_STRING = 'YYYY-MM-DD';
export const MS_PER_DAY = 24 * 60 * 60 * 1000;
export type TUnitOfTime = 'days' | 'months';
